import React from 'react'

function Carers() {
  return (
    <div>Carers</div>
  )
}

export default Carers